import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        padding: 40px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 16px;
    `,

    "PreviewImg": styled.img`
        width: 240px;
        height: 120px;
        object-fit: cover;
        object-position: center center;
        border-radius: 8px;
        margin: 8px 0;
    `,
    "PreviewVideo": styled.video`
        width: 240px;
        height: 120px;
        object-fit: cover;
        object-position: center center;
        border-radius: 8px;
        margin: 8px 0;
    `,
    "Radio": styled.button`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
}